import { Tag, TagColor, Tooltip } from '@cfa/react-components';

interface PlanCardTagProps {
  color: string;
  text: string;
  tooltip: string | React.ReactNode;
}

const PlanCardTag: React.FC<PlanCardTagProps> = ({ color, text, tooltip }) => (
  <>
    {tooltip ? (
      <Tooltip
        content={tooltip}
        placement="top"
        showOnElementEvents={['hover']}
      >
        <Tag
          color={color as TagColor}
          data-testid={'DateTag'}
          label={text}
          variant="filled"
          className="mt-2 self-start text-nowrap! md:mt-0 md:ml-2 md:self-center"
        />
      </Tooltip>
    ) : (
      <Tag
        className="text-nowrap!"
        color={color as TagColor}
        data-testid={'DateTag'}
        label={text}
        variant="filled"
      />
    )}
  </>
);

export default PlanCardTag;
